import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import Layout from '../layout';
import Stepper from '../../molecules/stepper';
import BannerQuoteInsured from '../../../modules/step-plans/banner-quote-insured';

const LayoutIntern = ({ children }) => {
  const itemsStepsRoutes = [
    '/comprar/seguro-salud-flexible/planes',
    '/comprar/seguro-salud-flexible/asegurados',
    '/comprar/seguro-salud-flexible/declaracion-salud',
    '/comprar/seguro-salud-flexible/direccion',
    '/comprar/seguro-salud-flexible/pago',
  ];

  const location = useLocation();

  return (
    <Layout>
      {location.pathname === itemsStepsRoutes[0] && <BannerQuoteInsured />}
      <Stepper
        currentStep={itemsStepsRoutes.indexOf(location.pathname) + 1}
        itemsStepsRoutes={itemsStepsRoutes}
        routeMain="/comprar/seguro-salud-flexible"
        hasBorderTop={itemsStepsRoutes.indexOf(location.pathname) > 0}
      />
      {children}
    </Layout>
  );
};

LayoutIntern.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutIntern;
